/**
 * Длительность разговора и таймер активного звонка.
 *
 * Секунды приходят с сервера как talk_sec — время в бридже, а не длительность канала
 * (спека §7.4). Пересчитывать и округлять их на клиенте нельзя: цифра на пульте
 * должна совпадать с цифрой в отчёте.
 */

/** 0:07, 3:42, 1:05:30 — таймер разговора */
export function formatDuration(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  const mm = hours > 0 ? String(minutes).padStart(2, '0') : String(minutes);
  const ss = String(seconds).padStart(2, '0');
  return hours > 0 ? `${hours}:${mm}:${ss}` : `${mm}:${ss}`;
}

/** «12 мин», «3 ч 20 мин» — суммарное время в разговоре за смену */
export function formatDurationLong(totalSeconds: number): string {
  const safe = Number.isFinite(totalSeconds) && totalSeconds > 0 ? Math.floor(totalSeconds) : 0;
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  if (hours === 0) return `${minutes} мин`;
  return `${hours} ч ${minutes} мин`;
}

/** Сколько идёт текущий звонок; startedAt и now — мс epoch */
export function elapsedSeconds(startedAt: number, now: number): number {
  return Math.max(0, Math.floor((now - startedAt) / 1000));
}
